<template>
  <div class="home">
    <div class="middle min-container">
      <div class="container">
        <div class="report_con">
          <div class="left center">
            <div
              class="left_item bg-color home-p-color"
              @click="toJump('legalPrivacy')"
            >
              Privacy Policy
            </div>
            <div
              class="left_item bg-color home-p-color"
              @click="toJump('legalTerms')"
            >
              Terms of Service
            </div>
            <div
              class="left_item bg-color home-p-color"
              @click="toJump('legalUnsolicited')"
            >
              Unsolicited Ideas
            </div>
            <div
              class="left_item bg-color home-p-color"
              @click="toJump('legalCommunity')"
            >
              Community Rules
            </div>
            <div
              class="left_item bg-color home-p-color"
              @click="toJump('legalCookies')"
            >
              Cookie Notice
            </div>
             <div
              class="left_item bg-color highlight"
              @click="toJump('legalPublic')"
            >
              Public Relationship
            </div>
          </div>
          <div class="right bg-color home-p-color">
            <div>
              <h2 class="title home-color">
                Public Relationship
              </h2>
              <p>Any information requests from public authorities <a style="color:black;text-decoration:underline;"><b>MUST</b></a> be submitted to <a href="mailto:pr@pppoker.net">pr@pppoker.net.</a> <a style="color:black;"><b> Any information requests submitted to platforms other than</b></a> <a href="mailto:pr@pppoker.net"> pr@pppoker.net</a> <a style="color:black;"><b> will </b></a> <a style="color:black;text-decoration:underline;"><b>not</b></a><a style="color:black;"><b> be processed.</b></a></p> 
              <p>We will be unable to process overly broad or vague requests. All requests must identify requested information with particularity.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  data () {
    return {
      index: 1
    }
  },
  created () {
    // this.index = parseInt(this.$route.params.item)
    this.$store.commit('changeTab', '/home')
  },
  mounted () {
    document
      .querySelector('#app')
      .scrollIntoView({ block: 'start', behavior: 'smooth' })
  },
  methods: {
    toJump (name) {
      this.$router.push({ name })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.home {
  position: relative;
  padding: 65px 0px 65px 0px;
  min-width: 1200px;
  .middle {
    color: #fff;
    position: relative;
    // background-color: #2a2a2a;
    padding: 0px;
    .report_con {
      display: flex;
      justify-content: space-around;
      align-items: flex-start;
      // min-height: 1000px;
      .left {
        position: relative;
        display: inline-block;
        width: 224px;
        .left_item {
          width: 220px;
          height: 55px;
          margin-bottom: 2px;
          display: flex;
          justify-content: center;
          align-items: center;
          cursor: pointer;
          .p1 {
            font-size: 14px;
            text-align: left;
          }
          .p2 {
            font-size: 12px;
            color: #7b7b7b;
            text-align: right;
          }
        }
        .highlight {
          background-color: #58b26d;
        }
      }
      .right {
        position: relative;
        width: 868px;
        display: inline-block;
        padding: 52px 44px;
        .title {
          font-size: 34px;
        }
        h2 {
          margin: 30px 0px 20px 0px;
          font-size: 28px;
        }
        h2:nth-child(1) {
          margin-top: 0px;
        }
        p {
          font-size: 14px;
          margin-bottom: 10px;
          line-height: 24px;
          a {
            color: #1f9d56;
          }
        }
      }
    }
  }
}
</style>
